import React from 'react';
import PropTypes from 'prop-types';
import HtmlToReact, { Parser } from 'html-to-react';

const htmlToReact = new Parser();
const isValidNode = () => true;
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const HtmlRender = ({ content, whitelistTags }) =>
  htmlToReact.parseWithInstructions(
    content,
    isValidNode,
    (whitelistTags
      ? [
          {
            shouldProcessNode: node =>
              node && node.name && !whitelistTags.includes(node.name),
            processNode: (node, children) => children,
          },
        ]
      : []
    ).concat([
      {
        shouldProcessNode: node => true,
        processNode: processNodeDefinitions.processDefaultNode,
      },
    ]),
  );

HtmlRender.propTypes = {
  content: PropTypes.string.isRequired,
  whitelistTags: PropTypes.arrayOf(PropTypes.string),
};

export const HtmlMarkup = ({ content, whitelistTags, errorMessage }) => (
  <HtmlRender content={content} whitelistTags={whitelistTags} />
);

HtmlMarkup.propTypes = {
  content: PropTypes.string.isRequired,
  whitelistTags: PropTypes.arrayOf(PropTypes.string),
  errorMessage: PropTypes.string,
};

export default HtmlMarkup;
